import * as React from "react";
import SelectField from "components/form/select-field";
import { Form } from "formsy-react";
import Checkbox from "material-ui/Checkbox";
import { formatMessage } from "lib/globalize-util";
import { NONE, SHOW_COST, SHOW_RETAIL, SHOP_TILE_LINE_SETTINGS } from "../manage-tile-view/constants";
import { merge, $ } from "glamor";
import { DATATEST } from "constants/integration";
import { IShopViewSettings } from "./types";

const styles = merge(
    $(" .linesContainer > div", {
        display: "block !important",
        marginLeft: "2px",
    }),
    $(" .checkboxContainer", {
        marginTop: "10px",
    }),
    $(" .checkboxContainer > div", {
        display: "flex !important",
    }),
    $(" .optionsCheck", {
        width: "150px !important",
        margin: "10px 0",
    }),
    $(" .optionsCheck + div", {
        display: "flex !important",
        alignItems: "center !important",
        flex: "1",
    })
);

interface IProps {
    settings: IShopViewSettings;
    onLineChange: (key: string) => (event, index, status) => void;
    onPriceChange: (key: string) => (event, index, status) => void;
    onCheckboxChange: (event, status) => void;
    fieldOptions: React.ReactNode;
    priceOptions: React.ReactNode;
}

export const FormView: React.FunctionComponent<IProps> = ({
    settings,
    fieldOptions,
    priceOptions,
    onLineChange,
    onCheckboxChange,
    onPriceChange,
}) => {
    return (
        <Form>
            <div {...styles}>
                <div className="linesContainer">
                    {SHOP_TILE_LINE_SETTINGS.map((line) => (
                        <SelectField
                            key={line.name}
                            label={<span className="label">{formatMessage(line.label)}</span>}
                            onChange={onLineChange(line.name)}
                            value={settings[line.name] || NONE}
                            name={line.name}
                            dataTest={line.dataTest}
                        >
                            {fieldOptions}
                        </SelectField>
                    ))}
                </div>
                <div className="checkboxContainer">
                    <div>
                        <Checkbox
                            className="optionsCheck"
                            checked={settings.showCost}
                            value={SHOW_COST}
                            onCheck={onCheckboxChange}
                            label={formatMessage("Show Cost")}
                            data-test={DATATEST.ASSORTMENTS.SHOP.SETTINGS.MODAL.FORM.SHOW_COST}
                        />
                        <SelectField
                            key={"cost"}
                            onChange={onPriceChange("cost")}
                            value={settings.cost || NONE}
                            name={"cost"}
                            disabled={!settings.showCost}
                        >
                            {priceOptions}
                        </SelectField>
                    </div>
                    <div>
                        <Checkbox
                            className="optionsCheck"
                            checked={settings.showRetail}
                            value={SHOW_RETAIL}
                            onCheck={onCheckboxChange}
                            label={formatMessage("Show Retail")}
                            data-test={DATATEST.ASSORTMENTS.SHOP.SETTINGS.MODAL.FORM.SHOW_RETAIL}
                        />
                        <SelectField
                            key={"retail"}
                            onChange={onPriceChange("retail")}
                            value={settings.retail || NONE}
                            name={"retail"}
                            disabled={!settings.showRetail}
                        >
                            {priceOptions}
                        </SelectField>
                    </div>
                </div>
            </div>
        </Form>
    );
};
